/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Fjern valg',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Kan ikke hente data',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klikk for å prøve igjen',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laster …',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mer',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Finner ingen treff',
  'paginated-picker.async-select.select.option.error-message': 'Kan ikke hente data',
  'paginated-picker.async-select.select.option.retry-message': 'Klikk for å prøve igjen',
  'paginated-picker.async-select.select.search-placeholder': 'Søk',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis fullstendig liste'
};